import * as React from "react";
import "./section.css";

interface Props {
  children?: string;
  titleRight?: React.ReactNode;
}

export const SectionTitle: React.FC<Props> = ({ children, titleRight }) => {
  return (
    <div className="section-title">
      <h2>{children}</h2>
      {titleRight}
    </div>
  );
};
